import React from 'react';
import { Typography } from 'antd';
import { legacyTextColor } from '@/utils/legacyColor';

const { Paragraph } = Typography;

interface CustomShipmentTextProps {
  text?: string;
  htmlString?: string;
  color?: string;
  strong?: boolean;
  fontSize?: string;
  lineHeight?: string;
  marginBottom?: string;
  marginTop?: string;
  fontWeight?: number | string;
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  whiteSpace?: string;
  ellipsis?: boolean;
  noText?: string;
  style?: React.CSSProperties;
  className?: string;
}

const CustomShipmentText: React.FC<CustomShipmentTextProps> = ({
  text,
  htmlString,
  color = 'var(--text-primary)',
  strong,
  fontSize = '12px',
  lineHeight = '16px',
  marginBottom = '0px',
  marginTop,
  fontWeight = 400,
  textAlign,
  whiteSpace,
  ellipsis = false,
  noText = '',
  style = {},
  className,
}) => {
  if (htmlString) {
    const divStyle: React.CSSProperties = {
      color: legacyTextColor(color),
      fontSize: fontSize,
      lineHeight: lineHeight,
      fontWeight: fontWeight,
      marginBottom: marginBottom,
      marginTop: marginTop,
      textAlign: textAlign,
      whiteSpace: whiteSpace,
      ...style,
    };
    return (
      <div
        className={className}
        style={divStyle}
        dangerouslySetInnerHTML={{ __html: htmlString }}
      />
    );
  }

  return (
    <Paragraph
      className={className}
      ellipsis={ellipsis}
      strong={strong}
      style={{
        color: legacyTextColor(color),
        marginTop: marginTop,
        fontSize: fontSize,
        lineHeight: lineHeight,
        fontWeight: fontWeight,
        marginBottom: marginBottom,
        textAlign: textAlign,
        whiteSpace: whiteSpace || 'pre-line',
        overflowWrap: 'break-word',
        ...style,
      }}
    >
      {text ? text : noText}
    </Paragraph>
  );
};

export default CustomShipmentText;
